<template>
  <div class="app">
    <router-view />
  </div>
</template>

<!-- <script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  setup() {
    
  },
})
</script> -->

<style lang="scss" scoped>
.app {
  width: 100vw;
  height: 100vh;
  background-color: #171e41;
  overflow: hidden;
}
</style>
